var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { ThemeProvider } from 'styled-components';
import { configureSDK, initializeSDK, logoutSession } from '../TransmitWebSdk';
import AuthFlowComponent from './AuthFlowComponent';
import BaseUIHandler from '../utils/BaseUIHandler';
import * as log from '../utils/log';
import findTheme from '../branding/findTheme';
import SyfLoader from './SyfLoader';
var AuthInitComponent = function (props) {
    var _a = useState(), transmitsdk = _a[0], setTransmitsdk = _a[1];
    var branding = props.params.branding, params = props.params, customUI = props.customUI, config = props.config, handleAuthResponse = props.handleAuthResponse;
    var data = JSON.parse(config);
    var applicationId = data.appId;
    var serverUrl = data.serverUrl, crypto = data.crypto, secureaccess = data.secureaccess, internal = data.internal;
    var myTheme;
    var list = data.authenticatorListing;
    var isQueueService = data.queueService;
    var maxAuthLevel = Object.keys(list).length;
    var appData = {
        serverUrl: serverUrl,
        policyId: '',
        applicationId: applicationId
    };
    var applyClientBranding = function () {
        var brandingObj = data.brandingObj || {};
        var runtimeBranding = branding || {};
        var clientappCustomBranding = data.customStyles || {};
        myTheme = findTheme(data.defaultUI, brandingObj, runtimeBranding, clientappCustomBranding);
    };
    applyClientBranding();
    var handleTransmitSession = function () {
        if (transmitsdk === null || transmitsdk === void 0 ? void 0 : transmitsdk.currentSession) {
            logoutSession(transmitsdk, data.isLoggingEnabled)
                .then(function (logoutResponse) {
                log.info('LogOutSessionSuccess', logoutResponse);
            })
                .catch(function (error) {
                log.error('Error', error);
            });
        }
    };
    var initializeTransmit = function (xmSdk) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    configureSDK(xmSdk, appData, crypto, secureaccess, internal, params, data);
                    return [4, initializeSDK(xmSdk, data.isLoggingEnabled)
                            .then(function (response) {
                            data.isLoggingEnabled &&
                                log.info('SDKIntialise Success', response);
                            handleTransmitSession();
                            setTransmitsdk(xmSdk);
                        })
                            .catch(function (error) {
                            data.isLoggingEnabled && log.error('SDK Initialise error', error);
                        })];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    useEffect(function () {
        var loadTransmitSdk = function () { return __awaiter(void 0, void 0, void 0, function () {
            var xmSdk;
            return __generator(this, function (_a) {
                if (!window.XmSdk) {
                    Promise.all([import('syf-transmit-library/dist/vendor/js/xmsdk-lite')])
                        .then(function (_a) {
                        var xmsdk = _a[0];
                        var xmSdk = xmsdk.XmSdk();
                        if (xmSdk) {
                            window.XmSdk = xmSdk;
                            initializeTransmit(xmSdk);
                        }
                    })
                        .catch(function (error) {
                        data.isLoggingEnabled && log.error('SDK import error', error);
                    });
                }
                else {
                    xmSdk = window.XmSdk;
                    initializeTransmit(xmSdk);
                }
                return [2];
            });
        }); };
        loadTransmitSdk();
    }, []);
    var handleResponse = function (response) {
        'next_step' in response && delete response.next_step;
        handleTransmitSession();
        setTransmitsdk(null);
        handleAuthResponse(response);
    };
    return (_jsx(_Fragment, { children: transmitsdk ? (_jsx(ThemeProvider, __assign({ theme: myTheme }, { children: _jsx(AuthFlowComponent, { params: params, appData: appData, handleAuthResponse: handleResponse, isQueueService: isQueueService, transmitsdk: transmitsdk, xmHandler: BaseUIHandler, maxAuthLevel: maxAuthLevel, theme: myTheme, analytics: data.analyticsObj, formatResponse: data.formatResponse, hasAnalytics: data.analytics, config: data, list: list, isLoggingEnabled: data.isLoggingEnabled, isVoiceEnabled: data.isVoiceEnabled, customUI: customUI, getComponent: function () {
                    return import('../baseComponents/IovationCheckSdkComponent');
                } }) }))) : (_jsx(SyfLoader, {})) }));
};
export default AuthInitComponent;
